import { type DecodedToken } from '@/shared/api/types';
import { parseJSON } from '@/shared/helpers/parse-json';

const base64UrlToBase64 = (base64Url: string): string => {
  return base64Url
    .replace(/-/g, '+')
    .replace(/_/g, '/')
    .padEnd(base64Url.length + ((4 - (base64Url.length % 4)) % 4), '=');
};

export const parseJWTToken = (token: string): DecodedToken | null => {
  try {
    // JWT payload is the second part
    const payloadBase64Url = token.split('.')[1];

    const payloadBase64 = base64UrlToBase64(payloadBase64Url);

    const decodedPayload = atob(payloadBase64);

    return parseJSON<DecodedToken>(decodedPayload);
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return null;
  }
};
